import { Quote } from "lucide-react";
import { ABOUT_FEATURES, PHILOSOPHY, VALUES } from "@/lib/content";
import { Reveal } from "@/components/site/Motion";
import { Icon } from "@/components/kit/Icon";

export function AboutFeatures() {
  return (
    <div className="rounded-[28px] bg-beige-soft p-7 ring-1 ring-forest/10 sm:p-9" data-testid="about-features">
      <ul className="space-y-6">
        {ABOUT_FEATURES.map((f) => (
          <li key={f.title} className="flex gap-4">
            <span className="icon-ring-light h-12 w-12"><Icon name={f.icon} className="h-5 w-5" /></span>
            <span>
              <span className="block font-display text-2xl text-forest">{f.title}</span>
              <span className="block text-sm text-charcoal-soft">{f.text}</span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Philosophy() {
  return (
    <figure className="relative rounded-[28px] bg-forest p-8 text-cream sm:p-10" data-testid="about-philosophy">
      <p className="eyebrow-dark">My philosophy</p>
      <Quote className="mt-5 h-7 w-7 text-gold" />
      <blockquote className="mt-3 font-display text-3xl leading-snug sm:text-4xl">{PHILOSOPHY}</blockquote>
    </figure>
  );
}

export function ValuesBand() {
  return (
    <section data-testid="values-band" className="grain relative bg-forest-deep py-16 sm:py-20">
      <div className="wrap relative grid grid-cols-2 gap-8 lg:grid-cols-4 lg:divide-x lg:divide-cream/10">
        {VALUES.map((v, i) => (
          <Reveal key={v.title} delay={i * 0.08} className="flex flex-col items-start gap-4 lg:items-center lg:px-6 lg:text-center">
            <span className="icon-ring h-14 w-14"><Icon name={v.icon} className="h-6 w-6" /></span>
            <span>
              <span className="block font-display text-2xl text-cream">{v.title}</span>
              <span className="mt-1 block text-sm text-cream/75">{v.text}</span>
            </span>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
